import * as React from "react";
function SvgIcon18(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 100 100" {...props}><path fill="#f3f3f3" d="M0 0h100v100H0z" /><path d="M56.19 51.022V49.12h-5.167V43.95h-1.904v5.168h-5.167v1.903h5.167v5.168h1.904v-5.168z" fill="#bcbcbc" /></svg>;
}
export default SvgIcon18;